module.exports = __webpack_public_path__ + "assets/img/3.77a478f5.jpg";